import { takeLatest, put } from "redux-saga/effects";
import axios from "utils/axios";
import actionCreator from "utils/actionCreator";
import { barbersActions } from "./barbers";

/**
 * Action Types
 */
export const barbersRecurringBlocksActionTypes = {
    SAVE_REQUEST: "@app/barbers/RECURRING_BLOCKS/SAVE/REQUEST",
    SAVE_SUCCESS: "@app/barbers/RECURRING_BLOCKS/SAVE/SUCCESS",
    SAVE_FAILURE: "@app/barbers/RECURRING_BLOCKS/SAVE/FAILURE",
    CLEAR_REQUEST: "@app/barbers/RECURRING_BLOCKS/CLEAR/REQUEST",
    CLEAR_SUCCESS: "@app/barbers/RECURRING_BLOCKS/CLEAR/SUCCESS",
    CLEAR_FAILURE: "@app/barbers/RECURRING_BLOCKS/CLEAR/FAILURE",
};

/**
 * Redux Actions
 */
export const barbersRecurringBlocksActions = {
    saveRequest: actionCreator(barbersRecurringBlocksActionTypes.SAVE_REQUEST),
    saveSuccess: actionCreator(barbersRecurringBlocksActionTypes.SAVE_SUCCESS),
    saveFailure: actionCreator(barbersRecurringBlocksActionTypes.SAVE_FAILURE),
    clearRequest: actionCreator(barbersRecurringBlocksActionTypes.CLEAR_REQUEST),
    clearSuccess: actionCreator(barbersRecurringBlocksActionTypes.CLEAR_SUCCESS),
    clearFailure: actionCreator(barbersRecurringBlocksActionTypes.CLEAR_FAILURE),
};

/**
 * Saga Functions
 */
export const sagas = {
    *save({ payload, resolve, reject }) {
        try {
            const { barberId, blocks } = payload;
            yield axios.put(`/barbers/${barberId}/recurring-blocks`, { blocks });

            const { data } = yield axios.get("/barbers");
            yield put(barbersActions.read(data));

            yield put(barbersRecurringBlocksActions.saveSuccess());
            if (resolve) resolve();
        } catch (error) {
            yield put(
                barbersRecurringBlocksActions.saveFailure(error.response?.data?.errors)
            );
            if (reject) reject(error);
        }
    },
    *clear({ payload, resolve, reject }) {
        try {
            const { barberId } = payload;
            yield axios.delete(`/barbers/${barberId}/recurring-blocks`);

            const { data } = yield axios.get("/barbers");
            yield put(barbersActions.read(data));

            yield put(barbersRecurringBlocksActions.clearSuccess());
            if (resolve) resolve();
        } catch (error) {
            yield put(
                barbersRecurringBlocksActions.clearFailure(error.response?.data?.errors)
            );
            if (reject) reject(error);
        }
    },
};

/**
 * Watchers
 */
export function* barbersRecurringBlocksWatchers() {
    yield takeLatest(barbersRecurringBlocksActionTypes.SAVE_REQUEST, sagas.save);
    yield takeLatest(barbersRecurringBlocksActionTypes.CLEAR_REQUEST, sagas.clear);
}
